// extracted by mini-css-extract-plugin
export var switchWrapper = "style-module--switchWrapper--1c05a";